export const isTouched = (fields: object) =>
	Object.values(fields).some((v) => v);
